import * as types from '../mutation-types';
import {unionState} from '../helpers';

const state = () => ({
	tables: [],
	schedule: {
		reserved_tables: [],
		available_tables: [],
	}
});

const actions = {
	fetchAll({commit}, {restaurantId, branchId}) {
		return axios.get(`/api/restaurants/${restaurantId}/branches/${branchId}/tables`).then(response => {
			commit(types.STORE_TABLES, response.data);

			return response.data;
		});
	},

	fetchSchedule({commit}, {restaurantId, branchId, date, from, to}) {
		return axios.get(`/api/restaurants/${restaurantId}/branches/${branchId}/tables/schedule`, {
			params: {
				date,
				from,
				to,
			}
		}).then(response => {
			commit(types.STORE_SCHEDULE, response.data);

			return response.data;
		});
	},

	fetch({commit}, {restaurantId, branchId, tableId}) {
		return axios.get(`/api/restaurants/${restaurantId}/branches/${branchId}/tables/${tableId}`).then(response => {
			commit(types.STORE_ONE_TABLE, response.data);

			return response.data;
		});
	},

	create({commit}, {restaurantId, branchId, number, number_of_people}) {
		return axios.post(`/api/restaurants/${restaurantId}/branches/${branchId}/tables`, {
			number,
			number_of_people,
		}).then(response => {
			commit(types.STORE_ONE_TABLE, response.data);

			return response.data;
		});
	},

	update({commit}, {tableId, restaurantId, branchId, number, number_of_people}) {
		return axios.put(`/api/restaurants/${restaurantId}/branches/${branchId}/tables/${tableId}`, {
			number,
			number_of_people,
		}).then(response => {
			commit(types.STORE_ONE_TABLE, response.data);

			return response.data;
		});
	},

	delete({commit},{restaurantId, branchId, tableId}){
		return axios.delete(`/api/restaurants/${restaurantId}/branches/${branchId}/tables/${tableId}`).then(response => {
			commit(types.DELETE_ONE_TABLE , tableId);
		});
	}
};

const mutations = {
	[types.STORE_TABLES](state, table) {
		state.tables = unionState(state.tables, table);
	},

	[types.STORE_ONE_TABLE](state, table) {
	    state.tables = unionState(state.tables, [table]);
	},

	[types.DELETE_ONE_TABLE](state, id) {
	    state.tables = state.tables.filter(f => f.id != id);
	},

	[types.STORE_SCHEDULE](state, schedule) {
		state.schedule = schedule;
	},
};

const getters = {
	getById: state => id => state.tables.find(f => f.id == id),
	getAll: state => branchId => state.tables.filter(n => n.branch_id === branchId),
};

export default {
	namespaced: true,
	state,
	mutations,
	actions,
	getters
};